import { CompanyOverviewCategory } from "../Data/CompanyOverview";

export const findByIds = (collection, propName, ids) => {
  let output = [];
  for (let i = 0; i < collection.length; i++) {
    if (ids.indexOf(collection[i][propName]) > -1) {
      output.push(collection[i]);
    }
  }
  return output;
};

export const getVetifiedSelectedCategories = (categories) => {
  let selectedCategories = categories.filter((c) => c.selected === true) || [];
  let outputCategories = [];

  for (let i = 0; i < selectedCategories.length; i++) {
    if (i === 0) {
      outputCategories.push(selectedCategories[i]);
    } else {
      const prevCategory = outputCategories[i - 1];

      const isAllQuestionAnswered = prevCategory.questions.every(
        (q) => q.selection !== null
      );

      if (!isAllQuestionAnswered || prevCategory?.modalResponded === "No") {
        break;
      }

      const isModalRequired =
        prevCategory.questions.filter((c) => c.selection === "Yes").length >=
        prevCategory.requiredCount;

      const isModalRequiredAndalreadySelected =
        isModalRequired && !!prevCategory.modalResponded;

      if (isModalRequiredAndalreadySelected || !isModalRequired) {
        outputCategories.push(selectedCategories[i]);
      } else {
        break;
      }
    }
  }

  return outputCategories;
};

export const validateCategory = (catId, allCategories) => {
  debugger;
  console.log(catId);
  console.log(allCategories);
};

export const isLastSelection = (categories, catId) => {
  return (
    catId === categories.reverse().find((c) => c.selected === true).categoryId
  );
};

export const showDynamicModal = (filingExcemptionCategories, cat) => {
  return (
    !isLastSelection(filingExcemptionCategories, cat.categoryId) &&
    cat.modalResponded == null &&
    cat.questions.every((q) => q.selection !== null) &&
    cat.questions.filter((c) => c.selection === "Yes").length >=
      cat.requiredCount
  );
};

export const resetAllCategoryAndQuestions = (
  defaultCategories,
  selectedCategoryIdsSet
) => {
  defaultCategories.forEach((cat) => {
    cat.selected = false;
    cat.modalResponded = null;
    cat.questions.forEach((q) => {
      q.selection = null;
    });
    if (selectedCategoryIdsSet.has(cat.categoryId)) {
      cat.selected = true;
    }
  });
};

export const getExemptionNames = (categories, showCompanyOverviewTemplate) => {
  let exemptionNames = [];
  let exemptedCategories = categories.filter(
    (c) =>
      c.selected === true &&
      c.questions.every((q) => q.selection !== null) &&
      c.questions.filter((q) => q.selection === "Yes")?.length >=
        c.requiredCount
  );
  exemptionNames = exemptedCategories.map((c) => {
    return {
      categoryTitle: c.categoryTitle,
      categoryId: c.categoryId,
    };
  });

  if (showCompanyOverviewTemplate) {
    const doesNotHaveLargeCompany = exemptionNames.every(
      (item) => item.categoryTitle !== CompanyOverviewCategory.categoryTitle
    );

    if (doesNotHaveLargeCompany) {
      exemptionNames = [
        {
          categoryTitle: CompanyOverviewCategory.categoryTitle,
          categoryId: CompanyOverviewCategory.categoryId,
        },
        ...exemptionNames,
      ];
    }
  }
  return exemptionNames;
};
